import React from "react";
import LeaveTypePage from "../../../component/leave-type/LeaveTypeList";

function LeaveType() {
  return (
    <div className="page-body">
      <LeaveTypePage />
    </div>
  );
}

export default LeaveType;
